const fromDtoToNcobSettings = (item) =>
  !item
    ? item
    : {
        onlineBooking: item.online_booking,
        ncobMode: item.ncob_mode,
        checkNcobAvailabilityUntil: item.check_ncob_availability_until,
        closestBookingTime: item.closest_booking_time,
        useNcobSmartAlg: item.use_ncob_smart_alg,
        bookNcobWithSame: item.book_ncob_with_same,
        salonNcobText: item.salon_ncob_text,
        ncobCancelWindow: item.ncob_cancel_window,
        salonNcobEmail: item.salon_ncob_email,
        salonNcobInfo: item.salon_ncob_info,
        salonStripeAccountStatus: item.salon_stripe_account_status,
        groupNcobTinyUrl: item.group_ncob_tiny_url,
        ncobTinyUrl: item.ncob_tiny_url,
        bookingTimings: item.booking_timings,
        profileImageUrl: item.profile_image_url,
        profileImage: item.profile_image,
        sendNcobEmailToStylists: item.send_ncob_email_to_stylists,
        ncobDepositSettings: item.ncob_deposit_settings,
        ncobCustomAmount: item.ncob_custom_amount,
        noShowProtection: item.no_show_protection,
        hasNcobStripeAccount: item.has_ncob_stripe_account,
        canTakeVoucherPayments: item.can_take_voucher_payments,
        salonNcobWelcomeMessage: item.ncob_welcome_message,
        salonNcobPatchTestCopy: item.ncob_patch_test_copy,
        preventPatchTestFromOverlappingAppointment: item.prevent_patch_test_from_overlapping_appointment,
      };

export default fromDtoToNcobSettings;
